module.exports = __webpack_public_path__ + "img/assorted-gold-plated-table-figurines-1099816.be9f9861.jpg";